import { useEffect, useState } from 'react';

export type ViewportOrientation = 'portrait' | 'landscape';

/**
 * Tracks the current viewport orientation via `(orientation: portrait)` media query.
 * SSR-safe (defaults to 'portrait'). Updates on rotation / resize.
 */
export function useViewportOrientation(): ViewportOrientation {
  const [orientation, setOrientation] = useState<ViewportOrientation>(() => {
    if (typeof window === 'undefined') return 'portrait';
    return window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
  });

  useEffect(() => {
    const mql = window.matchMedia('(orientation: portrait)');
    const handler = (e: MediaQueryListEvent) => setOrientation(e.matches ? 'portrait' : 'landscape');
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return orientation;
}
